const ScrollService = {};

ScrollService.to = function(offset, duration) {
    $('html, body').animate({
        scrollTop: offset
     }, duration);
}

export default ScrollService;
